import type { BrandKey } from './brand'

export function hasAccessibilityStatement(brand: BrandKey) {
  switch (brand) {
    case 'COMHEM':
    case 'TELIA_CLOUD':
    case 'HALEBOP':
    case 'TEST':
      return true
    case 'JOTTACLOUD':
    case 'MEDIAMARKT':
    case 'LETS_GO':
    case 'ONLIME_WL':
    case 'ELGIGANTEN':
    case 'PHONERO':
    case 'ELKO':
    case 'GIGANTTI':
    case 'OBOS':
    case 'SATURN':
    case 'ELKJOP':
    case 'GET':
    case 'TDC_NO':
      return false
    default: {
      const _exhaustive: never = brand
      return _exhaustive
    }
  }
}
